import styled from 'styled-components';

export const PageContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: 100%;
`;
